"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const material_top_tabs_1 = require("@react-navigation/material-top-tabs");
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const react_redux_1 = require("react-redux");
const Hamburger_1 = __importDefault(require("../../assets/icons/Hamburger"));
const components_1 = require("../../components");
const header_1 = require("../../components/header");
const ModalMenu_1 = __importDefault(require("../../components/modal/ModalMenu"));
const ModalSuccess_1 = __importDefault(require("../../components/modal/ModalSuccess"));
const Routes_1 = __importDefault(require("../../navigators/Routes"));
const DisconnectScreen_1 = require("../DisconnectScreen");
const ListArticleUserScreen_1 = require("./ListArticleUserScreen");
const ListHashtagScreen_1 = require("./ListHashtagScreen");
const ListNewArticleScreen_1 = require("./ListNewArticleScreen");
const Tab = (0, material_top_tabs_1.createMaterialTopTabNavigator)();
const ArticleScreen = (_props) => {
    const [visibleMenu, setVisibleMenu] = (0, react_1.useState)(false);
    const [visibleToast, setVisibleToast] = (0, react_1.useState)(false);
    const [contentToast, setContentToast] = (0, react_1.useState)("");
    const connected = (0, react_redux_1.useSelector)((state) => state.appReducer.connected);
    const dataUser = (0, react_redux_1.useSelector)((state) => state?.loginReducer?.dataProfile, react_redux_1.shallowEqual);
    const isAnonymousUser = dataUser?.registration_status == 0;
    if (!connected)
        return react_1.default.createElement(DisconnectScreen_1.DisconnectScreen, null);
    return (react_1.default.createElement(react_native_1.View, { style: { backgroundColor: '#f7f7f7', flex: 1 } },
        react_1.default.createElement(header_1.Header, { statusBarStyle: "dark-content", styleViewCenter: { alignItems: 'center' }, title: '記事を探す', styleContainer: {
                backgroundColor: 'white',
            }, leftIcon: react_1.default.createElement(Hamburger_1.default, null), onLeftPress: () => {
                setVisibleMenu(true);
            } }),
        react_1.default.createElement(Tab.Navigator, { tabBar: (props) => react_1.default.createElement(components_1.CustomTabBar, { ...props }), screenOptions: {
                swipeEnabled: false,
                lazy: true
            } },
            react_1.default.createElement(Tab.Screen, { name: Routes_1.default.NEW_ARTICLE_LIST, component: ListNewArticleScreen_1.NewArticleScreen, options: {
                    tabBarStyle: {},
                    tabBarLabel: '新着',
                } }),
            !isAnonymousUser && dataUser && (react_1.default.createElement(Tab.Screen, { name: Routes_1.default.LIST_ARTICLE_USER, component: ListArticleUserScreen_1.ListArticleUserScreen, options: {
                    tabBarStyle: {},
                    tabBarLabel: 'フォロー中',
                } })),
            react_1.default.createElement(Tab.Screen, { name: Routes_1.default.LIST_HASHTAG, component: ListHashtagScreen_1.ListHashtagScreen, options: {
                    tabBarStyle: {},
                    tabBarLabel: 'ハッシュタグ',
                } })),
        react_1.default.createElement(ModalMenu_1.default, { visible: visibleMenu, onClose: () => setVisibleMenu(false) }),
        react_1.default.createElement(ModalSuccess_1.default, { visible: visibleToast, onClose: () => setVisibleToast(false), content: contentToast })));
};
exports.default = ArticleScreen;
